import PropTypes from 'prop-types';
import PrebuiltPromotionCards from './prebuilt-promotion-cards.js';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Module that displays promotions as prebuilt promotion cards.
 * Promotions are retrieved from promotions store using locationId config property and applicablePage component prop.
 * Promotion cards will be displayed in carousel.
 *
 * @class PrebuiltPromotionCards
 * @memberof Mojito.Modules.Promotions
 */

/**
 * PrebuiltPromotionCards prop types.
 *
 * @property {string} applicablePage - The id of the applicable page where event cards will be shown. Example: 'homepage', 'tennis', 'basketball'.
 * @property {string} [selectedSportId] - Only the cards of this sport are shown when provided. Typically provided by {@link Mojito.Modules.SportsFilterContainer.module|SportsFilterContainer}.
 * @property {Function} [onSportsChange] - Callback fired with the sport ids of the cards whenever they change. Typically used to feed a {@link Mojito.Modules.SportsFilterContainer.module|SportsFilterContainer}.
 * @property {string} [class] - Class name assigned to the root element.
 * @memberof Mojito.Modules.Promotions.PrebuiltPromotionCards
 */

const propTypes = {
    applicablePage: PropTypes.string.isRequired,
    selectedSportId: PropTypes.string,
    onSportsChange: PropTypes.func,
    elementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    class: PropTypes.string,
};

export default UIView('PrebuiltPromotionCards', PrebuiltPromotionCards, propTypes);
